export default function Sparkline({ data, color = "#00F0FF", width = 80, height = 22 }) {
  if (!data || data.length === 0) return null;
  const min = Math.min(...data), max = Math.max(...data);
  const range = max - min || 1;
  const step = width / (data.length - 1);
  const pts = data
    .map((v, i) => `${i * step},${height - ((v - min) / range) * (height - 2) - 1}`)
    .join(" ");
  return (
    <svg width={width} height={height} className="overflow-visible">
      <polyline fill="none" stroke={color} strokeWidth="1.2" points={pts} opacity="0.9" />
      <polyline fill={color + "18"} stroke="none" points={`0,${height} ${pts} ${width},${height}`} />
    </svg>
  );
}
